import { EntityName } from '@adm/backend-entity';

import { DefaultAction, Models, UserRole } from '../../enums';

export const glossaryPermissions: Record<
  UserRole,
  { actions: Array<keyof typeof DefaultAction>; subject: Models; fields?: Array<EntityName> }[]
> = {
  [UserRole.Admin]: [
    {
      actions: [DefaultAction.read, DefaultAction.create, DefaultAction.update],
      subject: Models.Glossary,
    },
    {
      actions: [DefaultAction.read],
      subject: Models.Glossaries,
    },
  ],

  [UserRole.Operator]: [
    {
      actions: [DefaultAction.read, DefaultAction.create, DefaultAction.update],
      subject: Models.Glossary,
    },
    {
      actions: [DefaultAction.read],
      subject: Models.Glossaries,
    },
  ],

  [UserRole.OperatorWithoutPBAccess]: [
    {
      actions: [DefaultAction.read, DefaultAction.create, DefaultAction.update],
      subject: Models.Glossary,
    },
    {
      actions: [DefaultAction.read],
      subject: Models.Glossaries,
    },
  ],

  [UserRole.DeviceOperator]: [],

  [UserRole.OperatorReadAccess]: [
    {
      actions: [DefaultAction.read],
      subject: Models.Glossary,
    },
    {
      actions: [DefaultAction.read],
      subject: Models.Glossaries,
    },
  ],

  [UserRole.TtmOperator]: [],

  [UserRole.DeviceQualityOperator]: [],
};
